export { Heading1 } from "./Heading1";
